const ListHeader = props => {
  const {
    leftText,
    rightComponent,
    rightText,
    containerClassName = "px-8 py-6 flex flex-row justify-between border-b border-gray-200",
    leftTextClassName = "mr-4 text-xl font-bold",
    rightTextClassName = "pl-4 text-xl font-bold text-black",
  } = props || {};

  const renderRightComponent = () => {
    if (!rightComponent) return null;
    if (typeof rightComponent === "function") {
      return rightComponent();
    }
    return rightComponent;
  };

  return (
    <div className={containerClassName}>
      <div className="flex flex-row items-center">
        <div className={leftTextClassName}>{leftText}</div>
        {rightText && (
          <>
            |
            <div className={rightTextClassName}>{rightText}</div>
          </>
        )}
      </div>
      {renderRightComponent()}
    </div>
  );
};

export default ListHeader;
